export const SITE_URL = 'https://escaladeglasgow.com.br';

export const SEO_BY_ROUTE = {
  '/': {
    title: 'Escala de Glasgow: calculadora, tabela e interpretação',
    description: 'Calcule a Escala de Coma de Glasgow (ECG/GCS), veja abertura ocular, resposta verbal, resposta motora, interpretação do escore e ECG-P com pupilas.',
    canonicalPath: '/',
  },
  '/tabela': {
    title: 'Tabela da Escala de Glasgow: critérios e pontuação O, V e M',
    description: 'Consulte a tabela completa da Escala de Coma de Glasgow para adultos, com critérios de abertura ocular, resposta verbal e resposta motora e suas pontuações.',
    canonicalPath: '/tabela',
  },
  '/pediatrica': {
    title: 'Escala de Glasgow pediátrica: tabela e critérios por idade',
    description: 'Veja como aplicar a Escala de Coma de Glasgow pediátrica, incluindo adaptações da resposta verbal e critérios úteis na avaliação de lactentes e crianças.',
    canonicalPath: '/pediatrica',
  },
  '/ecg-p': {
    title: 'ECG-P: Glasgow com reatividade pupilar e cálculo do escore',
    description: 'Entenda a ECG-P, extensão da Escala de Coma de Glasgow que incorpora a reatividade pupilar, com explicação do ERP e do cálculo do escore combinado.',
    canonicalPath: '/ecg-p',
  },
  '/como-avaliar': {
    title: 'Como avaliar a Escala de Glasgow: aplicação passo a passo',
    description: 'Aprenda como avaliar abertura ocular, resposta verbal e resposta motora na Escala de Coma de Glasgow, com atenção a estímulos, registro e itens não testáveis.',
    canonicalPath: '/como-avaliar',
  },
  '/sobre': {
    title: 'Sobre a Escala de Glasgow online e a revisão médica do site',
    description: 'Conheça a proposta editorial da Escala de Glasgow online, como a calculadora funciona, critérios de privacidade e quem realiza a revisão técnica do conteúdo.',
    canonicalPath: '/sobre',
  },
  '/referencias': {
    title: 'Referências da Escala de Glasgow: fontes, estudos e revisão',
    description: 'Consulte as principais referências usadas no conteúdo da Escala de Glasgow, incluindo trabalhos originais, revisões e materiais técnicos sobre ECG/GCS e ECG-P.',
    canonicalPath: '/referencias',
  },
  '/privacidade': {
    title: 'Política de Privacidade | Escala de Glasgow',
    description: 'Política de privacidade do site Escala de Glasgow, incluindo informações sobre processamento local da calculadora, navegação e tratamento de dados.',
    canonicalPath: '/privacidade',
  },
  '/termos': {
    title: 'Termos de Uso | Escala de Glasgow',
    description: 'Termos de uso da calculadora e dos conteúdos da Escala de Glasgow, incluindo finalidade educacional, limitações e responsabilidade profissional.',
    canonicalPath: '/termos',
  },
};

export function absoluteCanonical(pathname) {
  const path = pathname === '/' ? '/' : pathname.replace(/\/$/, '');
  return `${SITE_URL}${path}`;
}
